import _app from '../../../server';

import React from 'react';
import PropTypes from 'prop-types';

import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';

const moment = require('moment');

const SummonTable = props => {
    const {
        sm,
        md,
        lg,
        xl,
        summons,
        isFilterOn,
        filter,
        dispatch,
        onRowSelected,
        getFilteredData,
        getData,
        token
    } = props;

    const { data, pagination } = summons;
    const { currentPage, itemPerPage, total } = pagination;
    const { byid, list } = data;

    let indexEnd = currentPage * itemPerPage;
    let indexStart = indexEnd - itemPerPage;
    if (indexEnd > total) {
        indexEnd = total;
    }

    let itemsList = list.slice(indexStart, indexEnd);
    let isItemNull = itemsList.find(e => {
        return e === -1;
    });

    let tableData = [];

    if (!isItemNull) {
        let bil = indexStart + 1;

        itemsList.forEach(id => {
            let summon = byid[id];

            let offName = <p style={{ color: 'red' }}>UNREGISTERED</p>;
            if (summon.offender.name && summon.offender.name !== '') {
                offName = summon.offender.name;
            }
            let vehicle = '';
            if (typeof summon.vehicle !== 'undefined') {
                vehicle = summon.vehicle.registration;
            }
            let item = {};

            const { patrollers } = summon.issuer;
            let names = patrollers.map(p => {
                return (
                    <p key={p.name} className='table-text-cont' >
                        {p.name}
                    </p >
                )
            });
            item['link'] = [];
            for (let i = 0; i < patrollers.length; i++) {
                let img_link;
                if (patrollers[i].container !== null && patrollers[i].filename !== null) {
                    img_link = `${_app.api}Storages/${patrollers[i].container}/download/${patrollers[i].filename}?access_token=${token}`;
                } else if (patrollers[i].link !== null) {
                    img_link = patrollers[i].link;
                }
                item['link'] = [...item['link'], img_link];
            }

            item['summoner_id'] = summon.summoner.id;
            item['summon_id'] = `${summon.id}`;
            item['bil'] = `${bil++}`;
            item['ref'] = summon.ref;
            item['issuedBy'] = <div>{names}</div>;
            item['callerId'] = summon.issuer.callerId;
            item['offenderName'] = offName;
            item['vehicle'] = vehicle;
            item['timestamp'] = moment(summon.createdAt).format(
                'YYYY/MM/DD hh:mm:ss A'
            );

            tableData.push(item);
        });
    } else {
        if (isFilterOn) {
            dispatch(getFilteredData(indexStart, itemPerPage, filter));
        } else {
            dispatch(getData(indexStart, itemPerPage));
        }
    }

    let imgFormatter = (links, row) => {
        let avatars = links.map(link => {
            return (
                <div className='table-img-cont' key={link} style={{ padding: "5px" }}>
                    <img
                        src={link}
                        height='100%'
                        alt=''
                    />
                </div>
            )
        })
        return (
            <div>
                {avatars}
            </div>
        );
    };

    let columns = [
        {
            dataField: 'reviewer_id',
            text: '#',
            headerClasses: 'table-col-head',
            sort: true,
            hidden: true
        },
        {
            dataField: 'summon_id',
            text: '#',
            headerClasses: 'table-col-head',
            sort: true,
            hidden: true
        },
        {
            dataField: 'bil',
            text: '#',
            headerClasses: 'table-col-head',
            sort: true,
            hidden: false,
            headerStyle: { whiteSpace: 'nowrap', width: '40px' }
        },
        {
            dataField: 'ref',
            text: 'Ref. Num.',
            headerClasses: 'table-col-head',
            headerStyle: { whiteSpace: 'wrap', width: '170px' },
            sort: true,
            hidden: sm
        },
        {
            dataField: 'link',
            text: ' ',
            headerClasses: 'table-col-head',
            headerStyle: { width: '90px' },
            formatter: imgFormatter,
            sort: false
        },
        {
            dataField: 'issuedBy',
            text: 'Issued By',
            hidden: md,
            headerClasses: 'table-col-head',
            sort: true
        },
        {
            dataField: 'callerId',
            text: 'Device',
            hidden: true,
            headerClasses: 'table-col-head',
            sort: true
        },
        {
            dataField: 'vehicle',
            text: 'Reg. Num.',
            headerClasses: 'table-col-head',
            hidden: lg,
            sort: true,
            align: 'center',
            headerStyle: () => {
                if (xl) {
                    return { textAlign: 'center', width: '15%' };
                }
            }
        },
        {
            dataField: 'offenderName',
            text: 'Name',
            headerClasses: 'table-col-head',
            sort: true
        },
        {
            dataField: 'timestamp',
            text: 'Date/Time',
            headerClasses: 'table-col-head',
            sort: true,
            align: 'center',
            headerStyle: () => {
                if (lg) {
                    return { textAlign: 'center', width: '28%' };
                }
                if (xl) {
                    return { textAlign: 'center', width: '22%' };
                }
            }
        }
    ];

    const rowEvents = {
        onDoubleClick: (e, row) => {
            onRowSelected(row);
        }
    };

    return (
        <BootstrapTable
            bootstrap4
            classes='table-md table-responsive-sm text-center align-middle'
            keyField='summon_id'
            data={tableData}
            columns={columns}
            striped
            condensed
            hover
            bordered={false}
            noDataIndication='Record not found'
            rowEvents={rowEvents}
        />
    );
};

SummonTable.propTypes = {
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    xl: PropTypes.bool,
    summons: PropTypes.object,
    isFilterOn: PropTypes.bool,
    filter: PropTypes.object,
    dispatch: PropTypes.func,
    onRowSelected: PropTypes.func,
    getFilteredData: PropTypes.func,
    getData: PropTypes.func,
    token: PropTypes.string
};

export default SummonTable;



// WEBPACK FOOTER //
// ./src/components/blocks/SummonTable/SummonTable.js